import React, { type ReactNode } from 'react'
import { TabList } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

interface PageTabListProps extends Record<string, unknown> {
  className?: string
  buttonBar?: React.ReactNode
}

export const PageTabList = ({ className, buttonBar, ...props }: PageTabListProps): ReactNode => {
  return (
    <div
      className={twMerge(
        `mb-5 ml-[min(-20px,calc(-1*(100vw-1536px)/2-20px))] flex w-screen items-center justify-between bg-background-secondary pr-10 pl-[max(20px,calc((100vw-1536px)/2+20px))] lg:pr-[max(20px,calc((100vw-1536px)/2+20px))]`,
        className,
      )}
    >
      <TabList {...props} />
      {buttonBar}
    </div>
  )
}
